module.exports = __webpack_public_path__ + "static/media/web-search-scanned-vs-alerts.80c0d79d.png";